// About AIDAN — outer layout with sub-nav rail and outlet.

import { NavLink, Outlet, useLocation } from "react-router-dom";

const SECTIONS: { to: string; label: string }[] = [
  { to: "/about/overview", label: "Overview" },
  { to: "/about/requirements", label: "Requirements" },
  { to: "/about/architecture", label: "Architecture" },
  { to: "/about/data-model", label: "Data model" },
  { to: "/about/api", label: "API" },
  { to: "/about/stack", label: "Tech stack" },
  { to: "/about/changelog", label: "Changelog" },
];

export function AboutLayout() {
  const loc = useLocation();
  const active = SECTIONS.find((s) => loc.pathname.startsWith(s.to))?.label ?? "Overview";

  return (
    <div className="lex-page">
      <header className="lex-page__head lex-about-hero">
        <span className="lex-eyebrow">ABOUT AIDAN</span>
        <h1 className="lex-display">
          Built to make reference data{" "}
          <span className="lex-display__em">make sense.</span>
        </h1>
        <p className="lex-page__sub">
          {active} — a guided tour through what AIDAN does, how it's built, and how it's used.
        </p>
      </header>

      <div className="lex-about-shell">
        <nav className="lex-about-subnav" aria-label="About sections">
          {SECTIONS.map((s) => (
            <NavLink
              key={s.to}
              to={s.to}
              className={({ isActive }) =>
                "lex-about-subnav__link" + (isActive ? " is-active" : "")
              }
            >
              {s.label}
            </NavLink>
          ))}
        </nav>
        <div className="lex-about-main">
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export default AboutLayout;
